export default "__VITE_ASSET__D9NdY0HD__"